import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IBcContestStudent, permissions } from '../../../models/BcContest';

import { AppService } from '../../../services/app.service';
import { BcContestService } from '../../../services/bc-contest.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { BcContestApplicationsComponent } from '../applications/bc-contest-applications.component';
import { BcContestStudentEditComponent } from '../student-edit/bc-contest-student-edit.component';
import { bcState } from '../shared';

@Component({
    selector: 'app-bc-contest-students',
    templateUrl: './bc-contest-students.component.html',
    styleUrls: ['../bc-contest.scss']
})
export class BcContestStudentsComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: BcContestService,
        private modal: NgbModal
    ) { }

    @Input() set key(value: number) {
        this.load();
    }

    @Input() contestId: number;

    readonly columns: ITableColumn[] = [
        { property: 'FullName', label: 'bcContestStudent_lblFullName', sorts: true },
        { property: 'Program', label: 'bcContestStudent_lblProgram', sorts: true },
        { property: 'CreditPoints', label: 'bcContestStudent_lblCreditPoints', sorts: true, type: 'number' },
        { property: 'ApplicationCount', label: 'bcContestStudent_lblApplicationCount', sorts: true, type: 'number' },
        { property: 'Grade', label: 'bcContestStudent_lblGrade', sorts: true, type: 'number' },
        { property: 'CustomGrade', label: 'bcContestStudent_lblCustomGrade', sorts: true, type: 'number' },
        { width: '1px' }
    ];

    items: IBcContestStudent[] = [];
    page: number = 1;
    readonly pageSize: number = 10;
    total: number = 0;
    sortBy: string;
    sortDir: 'asc' | 'desc';
    autoPage: boolean;
    canEdit: boolean;

    readonly filters: {
        student?: string,
        program: { options: string[], value: string[] },
        creditPoints: { options: number[], value: number[] },
        countFrom?: number,
        countTo?: number,
        gradeFrom?: number,
        gradeTo?: number,
        customGradeFrom?: number,
        customGradeTo?: number
    } = {
            program: { options: [], value: [] },
            creditPoints: { options: [], value: [] }
        };

    get isReadOnly() {
        return bcState.getContest()?.Status == 'Completed';
    }

    get isOpened() {
        return !!bcState.getContest()?.IsOpened;
    }

    private filterTimeout: any;

    ngOnInit() {
        this.canEdit = this.app.currentUser.hasRight(permissions.edit);

        this.loadFilters();
    }

    onPage(event: number) {
        this.page = event;
        if (!this.autoPage) this.load();
    }

    onSort(event: { sortBy: string, sortDir: 'asc' | 'desc' }) {
        this.sortBy = event.sortBy;
        this.sortDir = event.sortDir;

        if (!this.autoPage) this.load();
    }

    edit(student: IBcContestStudent) {
        const ref = this.modal.open(BcContestStudentEditComponent);

        ref.componentInstance.data = student;
    }

    openApplications(student: IBcContestStudent) {
        const ref = this.modal.open(BcContestApplicationsComponent, { size: 'lg' });

        ref.componentInstance.data = {
            contestId: this.contestId,
            student: {
                id: student.Id,
                name: student.FullName,
                upn: student.Upn
            }
        };
    }

    filter() {
        if (this.filterTimeout) {
            clearTimeout(this.filterTimeout);
        }

        this.filterTimeout = setTimeout(() => {
            this.load();
        }, 300);
    }

    private load() {
        const cp = this.filters.creditPoints.value;
        const programs = this.filters.program.value;

        this.app.addLoading(this.service.getStudents(this.contestId, {
            student: this.filters.student,
            creditPoints: cp.length ? cp : undefined,
            programs: programs.length ? programs : undefined,
            countFrom: this.filters.countFrom,
            countTo: this.filters.countTo,
            gradeFrom: this.filters.gradeFrom,
            gradeTo: this.filters.gradeTo,
            customGradeFrom: this.filters.customGradeFrom,
            customGradeTo: this.filters.customGradeTo,
        }, {
            page: this.page,
            size: this.pageSize,
            sort: this.sortBy,
            dir: this.sortDir
        })).subscribe(data => {
            this.items = data.items;
            this.total = data.total;
            this.autoPage = data.items.length == data.total;
        });
    }

    private loadFilters() {
        this.app.addLoading(this.service.getFilters(this.contestId)).subscribe(data => {
            this.filters.program.options = data.Programs;
            this.filters.creditPoints.options = data.CreditPoints;
        });
    }
}
